import { Loader2 } from 'lucide-react';
import { useFieldLabel } from '../../../hooks/useFieldLabel';

interface DeleteGroupModalProps {
  isDeleting?: boolean;
  onCancel: () => void;
  onDelete: () => void;
}

export default function DeleteGroupModal({ isDeleting = false, onCancel, onDelete }: DeleteGroupModalProps) {
  const listLabel = useFieldLabel('MENU_LIST', 'List');
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/40 px-4 py-6" role="dialog" aria-modal="true">
      <div className="w-full max-w-md rounded-lg bg-white shadow-xl">
        <div className="border-b border-gray-200 px-5 py-4">
          <h2 className="mb-0 text-lg font-bold text-gray-900">Delete {listLabel}</h2>
        </div>

        <div className="px-5 py-5">
          <p className="mb-2 text-sm text-gray-800">Are you sure you want to delete this {listLabel.toLowerCase()}?</p>
          <p className="mb-0 text-sm text-gray-600">This action cannot be undone.</p>
        </div>

        <div className="flex justify-end gap-3 border-t border-gray-200 px-5 py-4">
          <button
            type="button"
            onClick={onCancel}
            disabled={isDeleting}
            className="inline-flex h-10 items-center justify-center rounded-lg border border-gray-200 px-4 text-sm font-semibold text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onDelete}
            disabled={isDeleting}
            className="inline-flex h-10 items-center justify-center gap-2 rounded-lg bg-red-600 px-4 text-sm font-semibold text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-red-300"
          >
            {isDeleting ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                Deleting...
              </>
            ) : (
              `Delete ${listLabel}`
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
